
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/keyword/go",
      function () {
        return require("private-next-pages/keyword/go.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/keyword/go"])
      });
    }
  